import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import CitationUI from './citationui';

export default class Citation extends Plugin {
  static get pluginName() {
    return 'Citation';
  }
  static get requires() {
    return [ CitationUI ];
  }
}
